import { useEffect } from "react";

import { MapView } from "./map/MapView";
import { Sidebar } from "./components/Sidebar";
import { DetailPanel } from "./components/DetailPanel";
import { YearSlider } from "./components/YearSlider";
import { LoginPage } from "./components/LoginPage";
import { useAuthStore } from "./state/useAuthStore";

export default function App() {
  const status = useAuthStore((s) => s.status);
  const check = useAuthStore((s) => s.check);

  useEffect(() => {
    check();
    // A session can lapse while the tab is parked in the background — the idle
    // timeout does not care that the page is still open. Re-asking when the
    // tab is looked at again turns "every panel is silently broken" into the
    // login screen it actually is.
    const onVisible = () => {
      if (document.visibilityState === "visible") check();
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, [check]);

  // Blank rather than a spinner: the session check is one local request, and a
  // flash of the login screen before it answers would be worse than a beat of
  // nothing.
  if (status === "checking") return <div className="h-full w-full bg-surface" />;
  if (status === "anonymous") return <LoginPage />;

  return (
    <main className="flex h-full w-full overflow-hidden">
      <Sidebar />
      {/* The map's own positioning context, so the panels floating over it
          stay clear of the rail rather than measuring from the window. */}
      <div className="relative min-w-0 flex-1">
        <MapView>
          <DetailPanel />
          <YearSlider />
        </MapView>
      </div>
    </main>
  );
}
